import React, { useEffect } from "react";
import "./Donation_Tracker.css";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { myAccount } from "../../features/my_account/Slice";
import { formatAmount, formatDate } from "../../utils/common";
import { AllDonations } from "../../features/admin/user_donation_details/Slice";

const Donation_Tracker = () => {
  const data = [
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "15.MAY.2025",
      mode: "Google Pay",
      amount: "₹1000/-",
      img: "/assets/images/donation_tracker/gpay.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
    {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    }, {
      doner: "Om Tapovan Ashram, Borbhatha(Bet), Golden Bridge, Bharuch",
      date: "19.MAY.2025",
      mode: "Google Pay",
      amount: "₹2000/-",
      img: "/assets/images/donation_tracker/phonepe.png",
    },
  ];

  const dispatch = useDispatch();

  const userDonationDetails = useSelector((state) => state.userDonationDetails);

  useEffect(() => {
    dispatch(AllDonations());
  }, [dispatch]);

  return (
    <section className="Donation_Tracker">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />

        <div className="main_content_div">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="left_img_div">
                <p className="big_text">
                  Selfless Initiative to make an impact!
                </p>

                <img
                  src="/assets/images/donation_tracker/left_img.png"
                  className="left_img"
                />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="white_card">
                <div className="all_cards_holder">
                  {
                    userDonationDetails?.data?.data?.length > 0 ? (
                      userDonationDetails?.data?.data?.map((item, index) => {
                        return (
                          <div className="donation_card" key={index}>
                            <div className="left_side">
                              <p className="doner_text">
                                {item?.Donation_Card?.name || ""}
                              </p>

                              <p className="date_text">
                                <b>Date :</b> {formatDate(item?.date)}
                              </p>

                              <div className="footer_div">
                                <div className="mode_div">
                                  <p className="text">Mode :</p>
                                  <div className="mode_type">
                                    {item?.Payment_Method?.name || " "}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="gray_box">
                              <p className="first_text">Amount</p>
                              <p className="amt_text">₹{item?.price || "0"}/-</p>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="no_data_found">
                        No Donations Found
                      </div>
                    )
                  }

                </div>

                <div className="total_div">
                  <p className="inner_text">Total Donation Amount</p>
                  <p className="amount_text">{formatAmount(userDonationDetails?.data?.total_donation)}/-</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Donation_Tracker;
